// extracted by css-extract-rspack-plugin
export default {"cls1":"SubtopicSection-cls1_Oin","cls2":"SubtopicSection-cls2_Op- SubtopicSection-cls1_Oin"};